import styled from 'styled-components'

import { Item as DefaultItem } from '../Styled'

export const Item = styled(DefaultItem)`
	min-height: 48px;

	&:active {
		background-color: unset;
	}
`
